import {
  z,
} from 'zod';

export const requestSchema = z.object({
  id: z.number(),
  json_data: z.object({
    startDate: z.coerce.string().transform(str => new Date(str)),
    endDate: z.coerce.string().transform(str => new Date(str)),
    document_types: z.string().array().optional(),
    clients: z.object({
      companyName: z.string(),
      ABN: z.string().length(11),
      ssid: z.string().length(10),
    }).array().optional(),
  }),
  display_status: z.enum([
    'Queued',
    'Failed',
    'Success',
  ]).optional(),
  request_status: z.enum([
    'processing',
    'fail',
    'success',
  ]),
  requested_by: z.string().email(),
});

export const requestsApiResponseSchema = requestSchema.array();

export type Request = z.infer<typeof requestSchema>;
export const requestWithIdSchema = requestSchema.required({
  id: true,
});
export type RequestWithId = z.infer<typeof requestWithIdSchema>;
export type RequestsApiResponse = z.infer<typeof requestsApiResponseSchema>;
